module.exports = __webpack_public_path__ + "img/10.b185ffe3.jpg";